import { Component, inject, OnInit, PLATFORM_ID, Inject, ChangeDetectionStrategy } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ActualiteService } from '../../_services/actualite/actualite.service';
import { Actualite } from '../../_interfaces/actualite';
import { SeoService } from '../../_services/seo/seo.service';
import { ActualiteContentComponent } from '../../_components/actualite-content/actualite-content.component';

@Component({
    selector: 'app-actualite-details',
    imports: [ActualiteContentComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './actualite-details.component.html'
})
export class ActualiteDetailsComponent implements OnInit {
  route = inject(ActivatedRoute);
  router = inject(Router);
  actualiteService = inject(ActualiteService);
  private seo = inject(SeoService);

  actualite?: Actualite;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }

    this.route.params.subscribe(params => {
      const id = params['id'];
      this.actualiteService.readOneActualite(id)
        .then(actualite => {
          const isPublished = actualite
            && new Date(actualite.date) <= new Date()
            && (actualite.statut ?? 'publie') === 'publie';
          if (isPublished) {
            this.actualite = actualite!;
            const resume = actualite!.contenu.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 155);
            this.seo.set({
              title: actualite!.titre,
              description: resume || `Actualité de La Bourrée de Paris : ${actualite!.titre}`,
              path: `/actualites/${id}`,
            });
          } else {
            this.router.navigate(['/actualites']);
          }
        })
        .catch(() => this.router.navigate(['/actualites']));
    });
  }
}
